import { AxiosResponse } from 'axios'
import 'date-fns'
import React, { useState } from 'react'
import InsuranceForm from '../components/forms/InsuranceForm'
import { useClaimant } from '../context/col'
import useAsync from '../hooks/useAsync'
import {
  CaseTypeType,
  InsuranceCaseType,
  InsuranceDataType,
  PostCaseReportRespType,
} from '../models'
import { postCaseReport } from '../services/case-report/post'
import {
  CaseReportPutInsuranceParams,
  putInsurance,
} from '../services/case-report/putInsurance'
import i18n from '../i18n/index'

export type InsurancePageProps = {
  transitions: InsurancePageTransitions
}

export type InsurancePageTransitions = {
  goBack: () => void
  goToTripPage: () => void // trip page == second page
  goToClaimantPage: () => void // trip page == second page
}

export const Insurance = (props: InsurancePageProps) => {
  const { state, dispatch } = useClaimant()
  const [ifEqual, setIfEqual] = useState<boolean>(false)

  const { fetch: postCaseReport_andUpdateState, pending } = useAsync({
    promiseFn: (params: any) => postCaseReport_internal(params),
  })

  function storeCaseReportPostResp(
    resp: PostCaseReportRespType,
    params?: InsuranceCaseType
  ) {
    localStorage.setItem('token', resp.token)
    dispatch({
      type: 'CaseReportCreated',
      payload: { postCaseReportResp: resp },
    })
  }
  const postCaseReport_internal = (value: InsuranceCaseType) => {
    return async () => {
      try {
        // AUTH == srvPostCaseReport
        const res: AxiosResponse<PostCaseReportRespType> = await postCaseReport(
          value
        )
        if (res.status >= 200 && res.status <= 202) {
          storeCaseReportPostResp(res.data, value)
          if (res?.status === 202) {
            props.transitions.goToTripPage()
          } else if (res?.status === 201) {
            props.transitions.goToClaimantPage()
          } else if (res?.status === 200) {
            props.transitions.goToClaimantPage()
          }
        } else {
          throw new Error(`Unknown response status: ${res.status}`)
        }
      } catch (error) {
        // console.log(error)
        if (error.response.status === 422) {
          dispatch({
            type: 'error',
            payload: { error: i18n.t('thirdPg.policyNumberNotFound') },
          })
          throw error
        }
        dispatch({ type: 'error', payload: { error: error.message } })
        throw error
      }
    }
  }

  // PUT /case-report/{id}/insurance
  const { fetch: putInsurance_andUpdateState, pending: pendingInsurance } =
    useAsync({
      promiseFn: (params: CaseReportPutInsuranceParams) =>
        putInsurance_internal(params),
      /* Nemělo by být nutné -- transitions již jsou.
    onData: () => {
      props.transitions.goToClaimantPage()
    },
    */
    })

  // PUT /case-report/{id}/insurance
  const putInsurance_internal = (params: CaseReportPutInsuranceParams) => {
    return async () => {
      try {
        // srvPutInsurance
        const res: any = await putInsurance(params)
        if (res?.status === 202) {
          props.transitions.goToTripPage()
        }
        if (res?.status === 200) {
          props.transitions.goToClaimantPage()
        }
      } catch (error) {
        // console.log(error)
        if (error.response.status === 422) {
          dispatch({
            type: 'error',
            payload: { error: error.message },
          })
          throw error
        }
        dispatch({ type: 'error', payload: { error: error.message } })
        throw error
      }
    }
  }

  const handleInsuranceDataPageBack = () => {
    props.transitions.goBack()
  }

  const handleInsuranceDataPageSubmitted = (
    insuranceDataParams: InsuranceDataType
  ) => {
    const insuranceCase: InsuranceCaseType = {
      caseType: state.caseType as CaseTypeType,
      insuranceData: { ...insuranceDataParams },
      webUserId: state.webUserId ?? undefined, // do not put webUserId if not specified
      claimant: state.webUser == null ? undefined : state.webUser.claimant, // put webUser.claimant as CaseReport.claimant
    }

    // Pokud mam case-report, tak posilam PUT /case-report/{id}/insurance
    // Pokud nemam, tak posilam inicialni POST /case-report
    if (state.caseReportId == null) {
      postCaseReport_andUpdateState(insuranceCase)
    } else {
      const putInsuranceCase: CaseReportPutInsuranceParams = {
        caseReportId: state.caseReportId,
        insuranceParams: insuranceCase,
      }
      putInsurance_andUpdateState(putInsuranceCase)
    }
  }

  const insuranceFormData = state.loadedCaseReportResp?.insurance ?? null

  return (
    <>
      <InsuranceForm
        viewMode={false}
        insuranceFormData={insuranceFormData}
        onPageContinue={handleInsuranceDataPageSubmitted}
        onPageBack={handleInsuranceDataPageBack}
        errorMessage={state.error}
        isContinueInProgress={pending}
        setIfEqual={setIfEqual}
        caseType={state.caseType}
      />
    </>
  )
}
